import { clientsListingService } from '@/app/features/clients/features/clients-listing/clients-listing.service';
import {
  ClientsListingGetters,
  ClientsListingMutations,
  ClientsListingActions
} from '@/app/features/clients/features/clients-listing/clients-listing.keys';
import i18n from '@/i18n';

export const getInitialState = () => {
  return {
    clientsList: [],
    searchParam: '',
    recordsCount: 0,
    clientsPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    },
    clientsSortingParameters: {
      sortBy: 'name',
      sortDirection: 'desc'
    },
    clientsFilterPreference: 'active',
    clientsTypeFilterPreference: ''
  };
};

export const clientsListingStore = {
  state: getInitialState,
  getters: {
    [ClientsListingGetters.ClientsList]: state => state.clientsList,
    [ClientsListingGetters.ClientsRecordsPerPage]: state =>
      state.clientsPaginationParameters.recordsPerPage,
    [ClientsListingGetters.ClientsRecordsOffset]: state => state.clientsPaginationParameters.offset,
    [ClientsListingGetters.ClientsRecordsCount]: state => state.recordsCount,
    [ClientsListingGetters.ClientsSortField]: state => state.clientsSortingParameters.sortBy,
    [ClientsListingGetters.ClientsSortDirection]: state =>
      state.clientsSortingParameters.sortDirection,
    [ClientsListingGetters.ClientsFilterPreference]: state => state.clientsFilterPreference,
    [ClientsListingGetters.ClientsTypeFilterPreference]: state => state.clientsTypeFilterPreference
  },
  mutations: {
    [ClientsListingMutations.SetClientsList](state, clientsList) {
      state.clientsList = clientsList;
    },
    [ClientsListingMutations.SetRecordsCount](state, clientsListCount) {
      state.recordsCount = clientsListCount;
    },
    [ClientsListingMutations.SetPaginationParameters](state, paginationParameters) {
      state.clientsPaginationParameters = paginationParameters;
    },
    [ClientsListingMutations.SetSortParameters](state, sortingParameters) {
      state.clientsSortingParameters = sortingParameters;
    },
    [ClientsListingMutations.SetClientsFilterPreference](state, clientsFilterParameter) {
      state.clientsFilterPreference = clientsFilterParameter;
    },
    [ClientsListingMutations.SetClientsTypeFilterPreference](state, clientsTypeFilterParameter) {
      state.clientsTypeFilterPreference = clientsTypeFilterParameter;
    },
    [ClientsListingMutations.ResetPaginationPropertyOffset](state) {
      state.clientsPaginationParameters.offset = 0;
    },
    [ClientsListingMutations.SetClientsSearchParam](state, searchParam) {
      state.searchParam = searchParam;
    }
  },
  actions: {
    [ClientsListingActions.RetrieveClientsList]({ state, commit }) {
      clientsListingService
        .getClientsList(
          state.clientsPaginationParameters,
          state.clientsSortingParameters,
          state.clientsFilterPreference,
          state.clientsTypeFilterPreference
        )
        .then(clientsList => {
          commit(ClientsListingMutations.SetClientsList, clientsList);
        })
        .then(
          clientsListingService
            .getFilteredClientsCount(
              state.clientsFilterPreference,
              state.clientsTypeFilterPreference,
              state.searchParam
            )
            .then(clientsRecordsCount => {
              commit(ClientsListingMutations.SetRecordsCount, clientsRecordsCount);
            })
        );
    },
    [ClientsListingActions.PaginationParametersUpdate]({ dispatch, commit }, paginationParameters) {
      commit(ClientsListingMutations.SetPaginationParameters, paginationParameters);
      dispatch(ClientsListingActions.RetrieveClientsList);
    },
    [ClientsListingActions.SortingParametersUpdate]({ dispatch, commit }, sortingParameters) {
      commit(ClientsListingMutations.SetSortParameters, sortingParameters);
      commit(ClientsListingMutations.ResetPaginationPropertyOffset);
      dispatch(ClientsListingActions.RetrieveClientsList);
    },
    [ClientsListingActions.ClientsFilterPreferenceUpdate](
      { dispatch, commit },
      clientsFilterParameter
    ) {
      commit(ClientsListingMutations.SetClientsFilterPreference, clientsFilterParameter);
      dispatch(ClientsListingActions.RetrieveClientsList);
    },
    [ClientsListingActions.ClientsTypeFilterPreferenceUpdate](
      { dispatch, commit },
      clientsTypeFilterParameter
    ) {
      commit(ClientsListingMutations.SetClientsTypeFilterPreference, clientsTypeFilterParameter);
      dispatch(ClientsListingActions.RetrieveClientsList);
    },
    [ClientsListingActions.DownloadClientsListAsExcel]({ state }, downloadPreference) {
      let clientsPaginationParameters = '';
      if (downloadPreference === i18n.t('clients.listing.actions.exportPage')) {
        clientsPaginationParameters = state.clientsPaginationParameters;
      }
      clientsListingService.downloadClientsXlsx(
        clientsPaginationParameters,
        state.clientsSortingParameters,
        state.clientsFilterPreference,
        state.clientsTypeFilterPreference,
        state.searchParam
      );
    },
    [ClientsListingActions.UpdateClientsList]({ commit, dispatch }, clientsList) {
      commit(ClientsListingMutations.SetClientsSearchParam, clientsList.searchParam);

      return dispatch(ClientsListingActions.RetrieveClientRecordCount).then(() => {
        commit(ClientsListingMutations.SetClientsList, clientsList.data);
      });
    },
    [ClientsListingActions.RetrieveClientRecordCount]({ state, commit }) {
      return clientsListingService
        .getFilteredClientsCount(
          state.clientsFilterPreference,
          state.clientsTypeFilterPreference,
          state.searchParam
        )
        .then(clientsRecordsCount => {
          commit(ClientsListingMutations.SetRecordsCount, clientsRecordsCount);
        });
    }
  }
};
